










































import { Component, Prop, Vue } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import { StateViewModel } from '@/features/bots/models/designer';
import IslandBadge from './IslandBadge.vue';
import { mixin as clickaway } from 'vue-clickaway';
import {validationMixin} from 'vuelidate';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import TagBox from '@/shared/components/TagBox.vue';
import { DecisionViewModel } from '@/features/bots/models/designer/decisionViewModel';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import Decision from '@/features/bots/components/designer/Decision.vue';
import { required } from 'vuelidate/lib/validators';
import shortid from 'shortid';
import { Getter } from 'vuex-class';

@Component({
	mixins: [
		clickaway,
		validationMixin
	],
	validations: {
		state : {
			noMatch: {
				required,
				type: {
					required
				},
				payload: {
					payloadValid(payload: string) {
						const component = (this as any);
						if (payload) {
							return !component.isTransitionPayloadInvalid(payload);
						}
						return true;
					}
				}
			}
		}
	},
	components: {
		Decision,
		Draggable,
		IslandBadge,
		AddIcon,
		TransitionPicker,
		TagBox,
		ErrorIcon
	},
})
export default class DecisionComponent extends Vue {
	@Prop() public value: StateViewModel;
	@Getter public isTransitionPayloadInvalid: (payload: string) => boolean;

	public state: StateViewModel = {
		id: '',
		component: 'decision',
		decisions: []
	};

	public decisions: DecisionViewModel[] = [];
	public invalid: boolean = true;

	public mounted() {
		if (this.value && this.value.decisions) {
			this.state = this.value;
			this.decisions = this.state.decisions || [];
			this.invalid = this.state.invalid === undefined ? false : this.state.invalid;
		}
	}

	public addDecision() {
		const decision = {
			transition: {
				type: undefined,
				payload: undefined
			},
			conditions: {
				type: 'and',
				conditions: []
			}
		} as DecisionViewModel;
		this.decisions.push(decision);
		this.$nextTick(() => this.decisionsChanged());
	}

	public deleteDecision(index: number) {
		if (this.decisions.length === 1) {
			return;
		}
		this.decisions.splice(index, 1);
		this.$nextTick(() => this.decisionsChanged());
	}

	public updateDecision(index: number, decision: DecisionViewModel) {
		this.decisions[index] = decision;
		this.decisionsChanged();
	}

	public updateDecisionsIfChanged() {
		if (this.state.decisions !== this.decisions) {
			this.decisionsChanged();
		}
	}

	public updateNoMatch(noMatch: TransitionViewModel) {
		this.state.noMatch = noMatch;
		this.state.decisions = this.decisions;
		this.emitUpdatedEvent();
	}

	public validateDecision() {
		this.$v!.state!.noMatch!.$touch();
		this.showAllDecisionValidationErrors();
	}

	public areDecisionsValid(): boolean {
		for (let i = 0; i < this.decisions.length; i++) {
			const componentName = `decision-component-${i}`;
			if (!this.decisionIsValid(componentName)) {
				return false;
			}
		}
		return true;
	}

	public showAllDecisionValidationErrors() {
		for (let i = 0; i < this.decisions.length; i++) {
			const componentName = `decision-component-${i}`;
			const component = (this.$refs[componentName]as any)[0] as Decision;
			if (component) {
				component.$v.providedDecision.$touch();
			}
		}
	}

	public createKey(decision: DecisionViewModel) {
		if (!decision.key) {
			decision.key = shortid.generate();
		}
		return decision.key;
	}

	private decisionsChanged() {
		this.state.decisions = this.decisions;
		this.emitUpdatedEvent();
	}

	private emitUpdatedEvent() {
		this.invalid = this.$v!.state!.noMatch!.$invalid || !this.areDecisionsValid();
		this.state.invalid = this.invalid;
		this.$emit('state-updated', this.state);
	}

	private decisionIsValid(componentName: string) {
		if (this.$refs[componentName] && (this.$refs[componentName] as any)[0]) {
			const component = (this.$refs[componentName]as any)[0] as Decision;
			return !(component && component.$v && component.$v.$invalid);
		}
	}
}
